import { PartnerConnector } from '@lumapps/marketplace/sdk';

import type { Connector } from '../types';
import { type GetConnectorListParams } from './connectorsApi';
import { type GetPartnerConnectorsListParams } from './partnerConnectorsApi';
import { type FetchProviderListParams } from './providersApi';

/**
 * Query keys object used to manage query keys
 *
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const marketplaceConnectorsQueryKeys = {
    all: () => ['marketplace-connectors'] as const,
    connectors: (params?: GetConnectorListParams) =>
        [...marketplaceConnectorsQueryKeys.all(), 'connectors', params] as const,
    connector: (connectorId: Connector['id']) => [...marketplaceConnectorsQueryKeys.connectors(), connectorId] as const,
    connectorAuthStatus: (connectorId: Connector['id']) =>
        [...marketplaceConnectorsQueryKeys.connectors(), connectorId, 'authorization-status'] as const,
    connectorTemplateValues: (connectorId: Connector['id']) =>
        [...marketplaceConnectorsQueryKeys.connector(connectorId), 'template-values'] as const,
    providers: (params?: FetchProviderListParams) =>
        [...marketplaceConnectorsQueryKeys.all(), 'providers', params] as const,
    provider: (providerId: string) => [...marketplaceConnectorsQueryKeys.providers(), providerId] as const,
    partnerConnectors: (params?: GetPartnerConnectorsListParams) =>
        [...marketplaceConnectorsQueryKeys.all(), 'partner-connectors', params] as const,
    partnerConnector: (parnterConnectorId: PartnerConnector['id']) =>
        [...marketplaceConnectorsQueryKeys.partnerConnectors(), parnterConnectorId] as const,
};
